import Axios, { AxiosError } from "axios";

// Axios.defaults.baseURL = "http://localhost";

Axios.interceptors.request.use(
  (config) => {
    console.log("Request", config);
    return config;
  },
  (error) => {
    return Promise.resolve(error);
  }
);

const redirect = () => {
  localStorage.removeItem("auth");
  window.location.href = "/";
};

Axios.interceptors.response.use(
  (response) => {
    console.log("Response", response);
    return response;
  },
  async (err: AxiosError) => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      redirect();
      return;
    }
    return Promise.resolve(err);
  }
);

export default Axios;
